// Shared plan/tier catalogue used by PaywallGate, /premium page, and any inline upsells.
// Keep price copy centralised so a single edit updates every surface.

export const PLANS = {
  persona_only_monthly: {
    lookup_key: "persona_only_monthly",
    tier: "persona_only",
    label: "Persona Only",
    price: "$2",
    per: "/ mo",
    interval: "month",
    tagline: "Deep-dive on your taste, nothing else",
  },
  pro_pass_monthly: {
    lookup_key: "pro_pass_monthly",
    tier: "pro_pass",
    label: "Monthly",
    price: "$5",
    per: "/ mo",
    interval: "month",
    tagline: "Cancel anytime",
  },
  pro_pass_yearly: {
    lookup_key: "pro_pass_yearly",
    tier: "pro_pass",
    label: "Yearly",
    price: "$39",
    per: "/ yr",
    interval: "year",
    tagline: "~$3.25/mo · 2 months free",
    badge: "Best value",
  },
};

// What each tier includes (used by /premium cards + paywall detail lists)
export const PERSONA_ONLY_INCLUDES = [
  "Unlimited Persona re-runs as your taste evolves",
  "Persona History timeline — see your archetype shift over time",
  "Rating & completion style breakdowns",
  "Full genre breakdown chart with weights",
];

export const PRO_PASS_EXTRAS = [
  "Discover — match with viewers who share your taste",
  "Seasonal Schedule — every currently-airing show, one tap to track",
  "Bulk Import from AniList & MyAnimeList",
];

export const FREE_INCLUDES = [
  "Unlimited catalogue, ratings, and notes",
  "AI recommendations + AI blurbs",
  "One free Persona Analysis result at 10 completed anime",
  "Year in Review Wrapped (shareable)",
  "Public profile at /u/{handle}",
];

// Which lookup_keys a paywall for a given tier should offer.
export const TIER_LOOKUP_KEYS = {
  persona_only: ["persona_only_monthly", "pro_pass_monthly", "pro_pass_yearly"],
  pro_pass: ["pro_pass_monthly", "pro_pass_yearly"],
};
